import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import logoImage from '../../Assest/logo.png';
import './Login.css'
import { Toast } from 'primereact/toast';
import { Api } from '../../services/api';
import axios from 'axios';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";

const Login = ({ handleLogin }) => {

  const toast = useRef(null);
  const [orgType, setOrgType] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add submitting state

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    organization: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted');
    setIsSubmitting(true); // Disable button

    const url = `${Api.API_BASE_URL}dologin`;

    try {
      console.log(formData.organization);
      formData.organization = selectedItem;
      const response = await fetch(url, {
        method: "POST",
        headers: Api.headers,
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.error) {
        console.log('Error:', data.error);
        toast.current.show({ severity: 'error', detail: data.error });
      } else {
        const { _id, email, first_name, last_name, role_id, name, permission_role, image, roles, rolesList, organizationId } = data.data;
        const token = data.token;
        console.log('user--details', data)
        localStorage.setItem('authToken', token);
        localStorage.setItem('loginTimestamp', Date.now().toString());
        toast.current.show({ severity: 'success', detail: data.message });
        console.log("data result", data.message)
        localStorage.setItem('isLogin', true);
        localStorage.setItem('isLoggedIn', true);
        localStorage.setItem('user_id', _id);
        localStorage.setItem('email', email);
        localStorage.setItem('name', `${first_name} ${last_name}`);
        localStorage.setItem('role_id', role_id._id);
        localStorage.setItem('role_name', name);
        localStorage.setItem('permission_role', role_id.permission_role);
        localStorage.setItem('image', image);
        localStorage.setItem('roles', roles);
        localStorage.setItem('rolesList', rolesList);
        localStorage.setItem('organizationId', organizationId._id)
        localStorage.setItem('organizationName', organizationId.title)
        localStorage.setItem('organizationLogo', organizationId.image)
        localStorage.setItem('isAdmin', role_id.isAdmin)

        if (data.data.role_id !== 1 && data.data.role_id !== 2) {
          setTimeout(() => {
            navigate('/');
            window.location.reload();
          }, 500);
        } else {
          setTimeout(() => {
            navigate('/');
            window.location.reload();
          }, 500);
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.current.show({ severity: 'error', detail: 'An error occurred during the login process.' });
    }finally {
      setIsSubmitting(false); // Re-enable the button after submission
    }
  };

  useEffect(() => {
    // console.log('Fetching org...xx');
    getOrgType();
  }, []);

  const getOrgType = (org) => {


    axios.get(Api.API_BASE_URL + 'get-active-organization')
      .then((response) => {
        const data = response.data.result;
        setOrgType(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching org:', error);
        setIsLoading(false);
      });
  };



  // Call the async function



  const [selectedItem, setSelectedItem] = useState(null);
  // const items = Array.from({ length: 20 }).map((_, i) => ({ label: `Organization #${i+1}`, value: i }));

  return (
    <div className="login-shell">
      <Toast ref={toast} />
      <div className="login-card">
        <div className="login-brand">
          <div className="logo-glow"></div>
          <img src={logoImage} alt="Builder Playbook" className='img-class' />
          <div>
            <strong>Builder Playbook</strong>
            <p className="brand-subtitle">Strategy | Execution | Performance</p>
          </div>
        </div>

        <h1>Welcome back</h1>
        <p className="text-muted">Sign in to continue to the Builder Playbook workspace.</p>

        <form onSubmit={handleSubmit}>
          <label className='login-label'>Email</label>
          <input className='input-log' type="email" placeholder="you@email.com" name="username" value={formData.username} onChange={handleInputChange} required />

          <label className='login-label'>Password</label>
          <div className="password-container">
            <input
              className='input-log'
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span className="toggle-password" onClick={togglePasswordVisibility}>
              {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
            </span>
          </div>

          <button className='button-login' type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="login-footer">
          <span>Need help? <Link to="/forget-password">Forgot password</Link></span>
          <span className="text-muted small">Secure access secured by PrimeReact</span>
        </div>
      </div>
    </div>
  );
};

export default Login;